import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';

export const createDependencyExperience = new UFOExperience('jira-business.timeline.linkIssues', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.Custom,
});

export const removeDependencyExperience = new UFOExperience('jira-business.timeline.unlinkIssues', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.Custom,
});
